import React from 'react';
import Icon from '@/components/ui/AppIcon';

const CTASection = () => {
  return (
    <section className="py-16 lg:py-24 bg-theme-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-white mb-6 leading-tight">
            Ready to Start Your Journey?
          </h2>
          <p className="text-lg text-white/90 font-body max-w-3xl mx-auto leading-relaxed mb-12">
            Join a community where championship-level training meets inclusive support. Whether you're 8 or 80, just starting or training for competition, GO Speed has a program designed for you.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a
              href="https://forms.gle/9yvnUPvV2ifJin4S9"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 bg-theme-orange text-white font-heading font-bold text-base rounded-lg shadow-card hover:shadow-hover transition-all duration-300 transform hover:-translate-y-0.5"
            >
              <Icon name="CalendarIcon" size={20} className="mr-2" />
              Book Free Trial Session
            </a>
            <a
              href="/programs-overview"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-theme-black font-heading font-bold text-base rounded-lg shadow-card hover:shadow-hover transition-all duration-300 transform hover:-translate-y-0.5"
            >
              <Icon name="AcademicCapIcon" size={20} className="mr-2" />
              Explore Programs
            </a>
          </div>

          <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm border border-white/20">
              <div className="text-3xl font-heading font-bold text-theme-orange mb-2">10+</div>
              <p className="text-white/90 font-body text-sm">Years of Excellence</p>
            </div>
            <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm border border-white/20">
              <div className="text-3xl font-heading font-bold text-theme-orange mb-2">2000+</div>
              <p className="text-white/90 font-body text-sm">Members Trained</p>
            </div>
            <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm border border-white/20">
              <div className="text-3xl font-heading font-bold text-theme-orange mb-2">98%</div>
              <p className="text-white/90 font-body text-sm">Satisfaction Rate</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;